import { SidebarItem } from "./SidebarItem";
import { ReactNode } from "react";

export interface SidebarConfigItem {
  name: string;
  path?: string;
  icon?: ReactNode;
  badge?: number;
  locked?: boolean;
  external?: boolean;
  subItems?: SidebarConfigItem[];
}

interface SidebarMenuProps {
  config: SidebarConfigItem[];
}

export const SidebarMenu = ({ config }: SidebarMenuProps) => {
  return (
    <div>
      {config.map((item) => (
        <SidebarItem key={item.name} item={item} />
      ))}
    </div>
  );
};
